<template>
    <v-layout row wrap v-if="!loading && cooks && cooks.length > 0">
            <v-flex xs12 sm4 mt-3 v-for="cook in cooks" :key="cook.id">
                <v-card v-if="cook.id" max-width="344" class="mx-auto">
                    <v-list-item>
                        <v-list-item-avatar color="grey"></v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="cook-1 text--primary" @click="goToCook(cook.id)">{{cook.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle> {{cook.createdBy.name}} - {{ cook.createdAt | moment("DD MMM YYYY") }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <iframe height="210" :src="cook.videoUrl.replace('https://youtu.be/', 'https://www.youtube.com/embed/')" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                    <v-card-text>
                        
                        <!-- <div class="text--primary" v-if="cook.ingredients">
                            {{cook.ingredients.substring(0,80)+"..."}}
                        </div> -->

                        <v-spacer></v-spacer>

                        <v-chip-group active-class="deep-purple accent-4 white--text" column>
                            <v-chip color="secondary" v-for="cat in cook.categories" :key="cat.id">{{cat.name}}</v-chip>
                        </v-chip-group>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn text color="black-text" :href="cook.videoUrl" target="_blank">
                            طريقة التحضير
                        </v-btn>

                        <v-btn text color="black-text" @click="goToCook(cook.id)">
                            تفاصيل 
                        </v-btn>

                        <v-btn icon color="black-text" v-if="user && user.id === cook.createdBy.id" @click="editCook(cook.id)">                            
                            <v-icon>mdi-pencil</v-icon>                        
                        </v-btn>

                        <v-btn icon color="black-text" v-if="user && user.id === cook.createdBy.id" @click="wantDelete(cook.id)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>

                        <!-- <v-spacer></v-spacer>
                        <v-btn icon>
                            <v-icon>mdi-heart</v-icon>
                        </v-btn>
                        <v-btn icon>
                            <v-icon>mdi-share-variant</v-icon>
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-flex>



            <v-dialog v-model="ensureDelete" width="500" >
        
                <v-card>

                    <v-card-text>
                    هل تريد حذف الطبخة بالتأكيد؟</v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="deleteCook(cookId)" >
                        نعم
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            ensureDelete: false,
            cookId: null
        }
    },
    props: ['loading', 'cooks'],
    computed: {
      ...mapGetters(['user'])
    },
    
    methods: {
        editCook(cookId) {
            this.$router.push(`/cook/edit/${cookId}`)
        },
        wantDelete(cookId) {
            this.ensureDelete = true
            this.cookId = cookId
        },
        deleteCook(cookId) {
            this.ensureDelete = false
            this.$emit("deleteCook", cookId)
        },
        goToCook(cookId) {
            this.$router.push(`/cooks/${cookId}`)
        }
    }
}
</script>

<style scoped>
.cook-1 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
    font-family: 'Almarai', sans-serif !important; /* this was it */
}

iframe {
    width: 100%
}
</style>